
import React from 'react';
import { Badge } from '@/components/ui/badge';
import StatusBadge from './StatusBadge';
import { Invoice } from '@/components/InvoiceList';

interface InvoiceHeaderProps {
  invoice: Invoice;
  formatCurrency: (value: number) => string;
}

const InvoiceHeader: React.FC<InvoiceHeaderProps> = ({ invoice, formatCurrency }) => {
  return (
    <div 
      className="rounded-t-xl p-8 text-white bg-cover bg-center bg-no-repeat"
      style={{ 
        backgroundImage: `linear-gradient(to right, rgba(99, 102, 241, 0.9), rgba(109, 40, 217, 0.9)), url('/hero-image-${invoice?.heroImage || 'business'}.jpg')` 
      }}
    >
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">{invoice.title}</h1>
          <p className="mt-2 opacity-80">#{invoice.id}</p>
        </div>
        <div className="text-right">
          <div className="text-3xl font-bold">{formatCurrency(invoice.amount)}</div>
          <div className="mt-1 opacity-80">Due {new Date(invoice.date).toLocaleDateString()}</div>
        </div>
      </div>
      
      <div className="mt-4">
        {invoice.status !== 'pending' && <StatusBadge status={invoice.status} />}
      </div>
    </div>
  );
};

export default InvoiceHeader;
